/**
 * @fileoverview POST handler for the "/apps/connected_content_credential/delete" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsConnectedContentCredentialDeleteCacheKeys } from "./constants";
import type {
  PostAppsConnectedContentCredentialDeleteProps,
  AppsConnectedContentCredentialDeleteResult,
} from "./types";

export const postAppsConnectedContentCredentialDelete = reactQueryMutationAdapter(
  appsConnectedContentCredentialDeleteCacheKeys,
  ({ id }: PostAppsConnectedContentCredentialDeleteProps): Promise<AppsConnectedContentCredentialDeleteResult> => {
    const params = {
      credential_id: id,
    };

    return fetch("/apps/connected_content_credential/delete", "POST", params);
  }
);
